// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Config$PorterinUtils from "../configs/Config.mjs";
import * as PageviewAnalyticsConfig$PorterinUtils from "./PageviewAnalyticsConfig.mjs";

function logPageview(payload) {
  var stringifiedPayload = Belt_Option.getWithDefault(JSON.stringify(payload), "");
  window.navigator.sendBeacon(Config$PorterinUtils.kafka_api_url + PageviewAnalyticsConfig$PorterinUtils.pageviewKafkaEndpoint, stringifiedPayload);
}

export {
  logPageview ,
}
/* Config-PorterinUtils Not a pure module */
